import { parseDate } from "../com/dateUtil";

// 공개키 받아오기
export const getPublicKey = async (conn) => {
  const response = await conn.get('push/publicKey');
  return response;
}

// 구독 여부 확인
export const checkSubscription = async (conn, data) => {
  const config = {
    params: {
      subscriptionId: data.subscriptionId,
    }
  };
  const response = await conn.get('push/checkSubscription', config);
  if(response.length > 1 || response.length === 0)
    return 0;
  else
    return 1;
}

// 구독 정보 저장
export const setSubscription = async (conn, data) => {
  const params = {
    subscriptionId: data.subscriptionId,
    userId: data.userId,
    gathDtm: parseDate("yyyy-mm-dd hh:mm:ss", data.gathDtm),
  };
  const response = await conn.post('push/subscription/', params);

  return response;  
}

// 구독 정보 삭제
export const deleteSubscription = async (conn, data) => {
  const config = {
    headers: { "Content-Type": "application/json" },
    params: {
      userId: data.userId,
      subscriptionId: data.subscriptionId,
    }
  }
  const response = await conn.delete('push/subscription', config);

  return response;
}

// PUSH 정보 저장
export const setPush = async (conn, data) => {

  const config = {
    userId: data.userId,
    push: data.push,
  }

  const response = await conn.post("push/pushYn", config);

  return response;
};

export const setPushTime = async (conn, data) => {

  const config = {
    userId: data.userId,
    pushTime: data.pushTime,
  }

  const response = await conn.post("push/pushTime", config);

  return response;
}

// 알림 이력 리스트 불러오기
export const getNotificationList = async (conn, data) => {
  const config = {
    params: {
      userId: data.userId,
      sentYn: data.sentYn,
      history: data.history,
      rgnCode: data.rgnCode,
      dongCode: data.dongCode,
      userTypeCode: data.userTypeCode,
    }
  }
  const response = await conn.get("push/notification", config);
  return response;
}

// 개별 알림 이력 리스트 불러오기
export const getNotificationListOne = async (conn, data) => {
  const config = {
    params: {
      userId: data.userId,
    }
  }
  const response = await conn.get("push/notification/one", config);
  return response;
}
